<template>
  <div class="error_msg_area">
    <div class="err_header">404. {{ $T('common.err.404.title') }}</div>
    <div class="err_msg">
      {{ $T('common.err.404.msg', { url: getUrl() }) }}
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    getUrl() {
      return location.pathname;
    },
  },
};
</script>
